import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Button, Fab } from '@material-ui/core';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { isMobile } from 'react-device-detect';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import CropFreeIcon from '@material-ui/icons/CropFree';
import { sendMobile } from '../../functions/mobile';
// import PaymentReduxForm from './DefaultUserForm';

const validate = values => {
    const error  = {}
    if (!values.cedule) {
        error.name = "El campo cédula es requerido"
    }
    if (!values.amount) {
        error.dni = "El monto es un campo obligatorio"
    }
    if (!values.description) {
        error.dni = "La descripción es un campo obligatorio"
    }
    return error
}
class ChargesForm extends Component {
    constructor(props) {
      super(props);
      this.state = { openDialog: false};
      // this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
      if (this.txt) {
        this.txt.focus();
      }
      if (isMobile) {
      }
    }
    openDialog = () => {
        this.setState({openDialog: true})
    }

    sendDataMobile = () => {
        let send = {
            type: 'action',
            action: 'openQRReader',
            data: true
        }
        sendMobile(JSON.stringify(send))
    }
    
    render() {
        const { classes, handleSubmit, findCustomer, owner, alert,
            QR, beneficiaryForm, openFormDialog, beneficiaryList, openBeneficiaryList, onCancel } = this.props;
        return (
            <React.Fragment>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                            { owner ? `Pagar a ${owner}` :  `Realizar Pago`}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={3} md={1}>
                        <Fab color="primary" aria-label="add" onClick = { () => openBeneficiaryList()  }>
                            <SearchIcon />
                        </Fab>
                    </Grid>
                    <Grid item xs={(window.ReactNativeWebView !== undefined) ? 3 : 3} md={1}>
                        <Fab color="primary" aria-label="add" onClick = { () => openFormDialog()  }>
                            <AddIcon />
                        </Fab>
                    </Grid>
                    {
                        (window.ReactNativeWebView !== undefined) &&
                        <Grid item xs={1} md={1}>
                            <Fab color="primary" aria-label="add" onClick = { () => this.sendDataMobile()  }>
                                <CropFreeIcon />
                            </Fab>
                        </Grid>
                    }
                    
                </Grid>
                <form className={classes.form} onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                        <Field
                            withFocus
                            name="cedule"
                            id="cedule"
                            required
                            component={ RenderTextFieldRedux }
                            label="Cédula"
                            fullWidth
                            onChange ={ e => { 
                                ((e.target.value.length === 10) || (e.target.value.length === 13)) &&
                                    findCustomer(e.target.value)
                            } }
                        />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Field
                                withFocus
                                name="owner"
                                id="owner"
                                disabled
                                component={ RenderTextFieldRedux }
                                label="Propietario"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Field
                                withFocus
                                name="amount"
                                id="amount"
                                required
                                component={ RenderTextFieldRedux }
                                label="Monto"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Field
                                withFocus
                                name="description"
                                id="description"
                                required
                                component={ RenderTextFieldRedux }
                                label="Descripción"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" type="submit"
                                // when={!pristine && !submitSucceeded}
                                onClick = {() => {this.openDialog()}}
                                fullWidth
                                color="primary"
                                className={classes.submit}>
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" className={classes.button} onClick = { () => onCancel() }>
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                </form>
                { alert }
                { QR }
                { beneficiaryForm }
                { beneficiaryList }
            </React.Fragment>
        )
    }
}
const ChargesReduxForm = reduxForm(
  {
    form: 'ChargesForm',
    validate
  }
)(ChargesForm)

ChargesForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    // customers: PropTypes.object.isRequired,
    findCustomer: PropTypes.func.isRequired,
    owner: PropTypes.string,
    cedule: PropTypes.string,
};
export default setPropsAsInitial(ChargesReduxForm)
// export default ChargesForm;